module.exports = __webpack_public_path__ + "fonts/e9167238-3b3f-4813-a04a-a384394eed42.e1d3b59.eot";


//////////////////
// WEBPACK FOOTER
// ./static/fonts/AvenirNext/e9167238-3b3f-4813-a04a-a384394eed42.eot
// module id = 84
// module chunks = 245 246